import React from 'react'
import { listingBusinessId } from '../../lib/analytics-content.mjs'
import { Panel, Row, PanelLink } from './listing-info-panel.styles'

// Listings whose owners have an agreed link relationship with the guide.
// Keyed by slug (document IDs are `listing-<slug>`).
const COMMERCIAL_LINK_PARTNERS = {
  'boni-beach-lombok': { website: true, booking: true, instagram: true },
  'boni-beach-restaurant-rooftop-bar': {
    website: true,
    booking: true,
    instagram: true,
  },
  'burudika-bungalows': { website: true, booking: true },
  'kai-lani-villa': { website: true, booking: true },
  'kairos-boutique-sports-hotel-lombok': { website: true, booking: true },
  // Books direct over WhatsApp rather than a booking URL, so website only.
  'villa-bareng-bareng': { website: true },
  // Instagram link supplied by the guide owner for this café.
  sookla: { instagram: true },
}

export const ListingInfoPanel = ({ listing }) => {
  const { contact = {}, links = {}, category, area, verified } = listing
  const isAccommodation = listing.sectionPage === 'Where to Stay'
  const isBoniBeach = ['listing-boni-beach-lombok', 'listing-boni-beach-restaurant-rooftop-bar'].includes(listing._id)
  // Commercial outbound links are intentionally limited to current inclusion
  // partners. `booking` is only enabled where the property supplied a direct
  // booking URL — OTA links stay suppressed for everyone else. Expand this
  // rule when the paid listing programme launches.
  const partner =
    COMMERCIAL_LINK_PARTNERS[listing.slug?.current] ||
    COMMERCIAL_LINK_PARTNERS[String(listing._id).replace(/^listing-/, '')] ||
    {}
  const bookingLink = partner.booking ? links.booking : null

  return (
    <Panel
      data-ga-item-name={listing.location}
      data-ga-item-category={category || ''}
      data-ga-item-section={listing.sectionPage || ''}
      data-analytics-module-id={`${listing._id || listing.slug?.current}-details`}
      data-analytics-module-type="listing_information"
      data-analytics-business-id={listingBusinessId(listing)}
      data-analytics-business-name={listing.location || ''}
      data-analytics-business-category={category || ''}
      data-analytics-business-area={area || ''}
      data-analytics-business-section={listing.sectionPage || ''}
      data-analytics-editors-pick={listing.editorsPick ? 'true' : 'false'}
    >
      {category && <Row><strong>Category:</strong> {category}</Row>}
      {area && <Row><strong>Area:</strong> {area}</Row>}
      {listing.locationReference && <Row><PanelLink href={listing.locationReference.sourceUrl} target="_blank" rel="noopener noreferrer" data-analytics-cta-id={`${listing._id}-directions`} data-analytics-cta-type="directions" data-analytics-placement-id="listing-information">Open location</PanelLink>{listing.locationReference.coLocatedWithName ? ` · Shares the location with ${listing.locationReference.coLocatedWithName}` : listing.locationReference.pointSemantics === 'property_reference' ? ' · Property location; confirm the entrance' : ''}</Row>}
      {verified && contact.openingHours && <Row><strong>Hours:</strong> {contact.openingHours}</Row>}
      {verified && contact.priceRange && contact.priceRange !== 'VERIFY' && (
        <Row><strong>Price:</strong> {contact.priceRange}</Row>
      )}
      {verified && contact.phone && (
        <Row><strong>Phone:</strong> <PanelLink href={`tel:${contact.phone.replace(/\s/g, '')}`} data-analytics-cta-id={`${listing._id}-phone`} data-analytics-cta-type="phone" data-analytics-placement-id="listing-information">{contact.phone}</PanelLink></Row>
      )}
      {partner.website && links.website && (
        <Row><PanelLink href={links.website} target="_blank" rel="noopener noreferrer" data-analytics-cta-id={`${listing._id}-website`} data-analytics-cta-type="website" data-analytics-placement-id="listing-information">{isBoniBeach ? 'Explore Boni Beach' : 'Website'}</PanelLink></Row>
      )}
      {bookingLink && (
        <Row><PanelLink href={bookingLink} target="_blank" rel="noopener noreferrer" data-analytics-cta-id={`${listing._id}-booking`} data-analytics-cta-type="booking" data-analytics-placement-id="listing-information">{isAccommodation ? 'Check availability' : 'Book now'}</PanelLink></Row>
      )}
      {partner.instagram && !isAccommodation && links.instagram && (
        <Row><PanelLink href={links.instagram} target="_blank" rel="noopener noreferrer" data-analytics-cta-id={`${listing._id}-instagram`} data-analytics-cta-type="website" data-analytics-placement-id="listing-information">Instagram</PanelLink></Row>
      )}
    </Panel>
  )
}
export default ListingInfoPanel
